import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

const style = {
  grid: {
    padding: "2px 8px"
  }
};

function GridItem({ ...props }) {
  const { classes, gridCss, children, ...rest } = props;
  return (
    <Grid item style={{ ...gridCss }} {...rest} className={classes.grid}>
      {children}
    </Grid>
  );
}

export default withStyles(style)(GridItem);
